/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Whether the task is locked based on unlock conditions
 */
export type EventTaskConfigLocked = boolean | null;
